import React from "react";
import { AiOutlineWhatsApp } from "react-icons/ai";

function WhatsappOverlay() {
  const openWhatsapp = () => {
    const number = "+233502835422";
    const text = encodeURIComponent(
      "Hello, I need to know more about your products https://ecoshoppegh.com",
    );
    const whatsappURL = `https://wa.me/${number}?text=${text}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <div className="fixed bottom-8 right-4 z-[99999] w-fit">
      <div
        className="size-14 flex items-center justify-center bg-black/90 
                 rounded-full text-white hover:bg-black sm:size-16"
      >
        <button onClick={openWhatsapp}>
          <AiOutlineWhatsApp size={30} />
        </button>
      </div>
    </div>
  );
}

export default WhatsappOverlay;
